import { HiX } from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";
import {
  MdHandshake,
  MdOutlineCardMembership,
  MdOutlineEmojiEvents,
  MdOutlineHelpOutline,
  MdOutlineLightbulb,
  MdOutlineShare,
  MdPerson,
  MdOutlineReceiptLong,
  MdOutlineSpaceDashboard,
} from "react-icons/md";

const NAV = [
  {
    path: "dashboard",
    label: "Dashboard",
    icon: MdOutlineSpaceDashboard,
  },
  {
    path: "subscription",
    label: "Subscription",
    icon: MdOutlineCardMembership,
    subtitles: [
      {
        label: "Path 1: Broker partner",
        icon: MdHandshake,
        to: "/client/subscriptions/Path1BrokerPartner",
      },
      {
        label: "Path 2: Personal Broker",
        icon: MdPerson,
        to: "/client/subscriptions/Path2PersonnalBroker",
      },
    ],
  },
  { path: "referral", label: "Referral", icon: MdOutlineShare },
  { path: "contest", label: "Contest", icon: MdOutlineEmojiEvents },
  { path: "billing", label: "Billing & payments", icon: MdOutlineReceiptLong },
  {
    path: "support",
    label: "Support & help",
    icon: MdOutlineHelpOutline,
    subtitles: [
      {
        label: "Help & tickets",
        icon: MdOutlineHelpOutline,
        to: "/client/support",
      },
      {
        label: "Suggestions",
        icon: MdOutlineLightbulb,
        to: "/client/support/suggestions",
      },
    ],
  },
];

export default function ClientSidebar({ open, onClose }) {
  const location = useLocation();

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full w-[313px] max-w-[90vw] flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <button
        type="button"
        className="absolute top-4 right-4 cursor-pointer rounded p-1 text-navy-700 dark:text-white xl:hidden"
        onClick={onClose}
        aria-label="Close menu"
      >
        <HiX className="h-6 w-6" />
      </button>

      <div className="mx-[38px] mt-[28px] flex items-center justify-center">
        <Link to="/" aria-label="Home" className="block">
          <img
            src={`${process.env.PUBLIC_URL}/AlphaSniperTradingLogo.png`}
            alt="AlphaSniper Trading"
            className="h-auto w-full max-w-[170px] rounded-lg"
          />
        </Link>
      </div>
      <div className="mx-[38px] mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />

      <ul className="mb-auto max-h-[calc(100vh-220px)] overflow-y-auto pt-1 pr-1">
        {NAV.map((item) => {
          const to = `/client/${item.path}`;
          const active =
            location.pathname === to ||
            location.pathname.startsWith(`${to}/`);
          const Icon = item.icon;
          return (
            <div key={item.path} className="relative mb-2">
              <Link
                to={to}
                onClick={() => {
                  if (typeof window !== "undefined" && window.innerWidth < 1200) {
                    onClose?.();
                  }
                }}
                className="block"
              >
                <li className="my-[3px] flex cursor-pointer items-center px-8 hover:cursor-pointer">
                  <span
                    className={
                      active
                        ? "font-bold text-brand-500 dark:text-white"
                        : "font-medium text-gray-600 dark:text-gray-400"
                    }
                  >
                    <Icon className="h-6 w-6 shrink-0" />
                  </span>
                  <p
                    className={`leading-1 ml-4 flex ${
                      active
                        ? "font-bold text-navy-700 dark:text-white"
                        : "font-medium text-gray-600 dark:text-gray-400"
                    }`}
                  >
                    {item.label}
                  </p>
                </li>
              </Link>

              {Array.isArray(item.subtitles) && item.subtitles.length ? (
                <div className="mt-0">
                  {item.subtitles.map((subtitle) => {
                    const SubtitleIcon = subtitle.icon;
                    const subtitleActive = location.pathname === subtitle.to;
                    return (
                      <Link
                        key={subtitle.label}
                        to={subtitle.to}
                        onClick={() => {
                          if (typeof window !== "undefined" && window.innerWidth < 1200) {
                            onClose?.();
                          }
                        }}
                        className="block"
                      >
                        <li className="my-[3px] flex cursor-pointer items-center pl-14 pr-8">
                          {SubtitleIcon ? (
                            <span
                              className={
                                subtitleActive
                                  ? "font-bold text-brand-500 dark:text-white"
                                  : "font-medium text-gray-600 dark:text-gray-400"
                              }
                            >
                              <SubtitleIcon className="h-6 w-6 shrink-0" />
                            </span>
                          ) : null}
                          <p
                            className={`leading-1 ml-4 flex ${
                              subtitleActive
                                ? "font-bold text-navy-700 dark:text-white"
                                : "font-medium text-gray-600 dark:text-gray-400"
                            }`}
                          >
                            {subtitle.label}
                          </p>
                        </li>
                      </Link>
                    );
                  })}
                </div>
              ) : null}

              {active ? (
                <div className="absolute top-px right-0 h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
              ) : null}
            </div>
          );
        })}
      </ul>
    </div>
  );
}
